import styled from 'styled-components';
import { Box } from '@components/common';

// TODO: need to be able to customized with breakpoits set in theme
//       eg. width=[1,2,3,4]

const MobileContainerWrapper = styled(Box)`
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  @media screen and (min-width: 1024px) {
    min-width: 300px;
    max-width: 340px;
    width: 340px;
    justify-content: flex-start;
    align-items: stretch;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    min-width: 200px;
    max-width: 340px;
    width: 340px;
    justify-content: flex-start;
    align-items: stretch;
  }
  @media screen and (max-width: 767px) {
    min-width: 300px;
    width: 100%;
    max-width: 345px;
    justify-content: center;
    align-items: stretch;
  }
`;

MobileContainerWrapper.defaultProps = {
  pt: [0, 6]
};

export default MobileContainerWrapper;
